import {ChangeDetectorRef, Component, Input, OnChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';
import {LocalStorageService} from '../_services/local-storage.service';

@Component({
    selector: 'icon',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div [ngClass]="'block '+class" [innerHTML]="svgIcon"></div>
    `
})
export class IconsComponent implements OnChanges {
    @Input() name: string;
    @Input() class: string;
    @Input() title: string;
    @Input() path: string = '/assets/_icons';
    @Input() strokeWidth: string = '2';
    svgIcon: any;

    constructor(
        private httpClient: HttpClient,
        private sanitizer: DomSanitizer,
        private changeRef: ChangeDetectorRef,
        private lSvc: LocalStorageService
    ) {
    }

    public ngOnChanges(): void {
        if (!this.name) {
            this.svgIcon = '';
            return;
        }

        if (this.name) {
            if (this.lSvc.globalState[this.name]) {
                let value: any = this.lSvc.globalState[this.name];
                value = this.updateStrokeWidth(value, this.strokeWidth);
                this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(value);
            } else {

                let base = this.path ?? '/assets/_icons/';
                if (!base.endsWith('/')) base += '/';
                let fullPath:string = `${base}${this.name}.svg`;
                this.httpClient
                    .get(fullPath, { responseType: 'text' })
                    .subscribe(value => {
                        value = this.updateStrokeWidth(value, this.strokeWidth);
                        this.lSvc.saveGState(this.name, value);
                        this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(value);
                        this.changeRef.detectChanges();
                    });
            }


        }

    }
    private updateStrokeWidth(svg: string, strokeWidth: string): string {
        return svg.replace(/stroke-width="[^"]*"/g, `stroke-width="${strokeWidth}"`);
    }

}
